import { Component, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { PrivilegeIndicatorService } from "./privilege-indicator.service";

@Component({
	selector: 'privilege-indicator',
	templateUrl: './privilege-indicator.component.html'})
export class PrivilegeIndicatorComponent implements OnInit {
	privileges: string[] = [];
	
	constructor(private cookieService: CookieService,
		private privilegeIndicatorService: PrivilegeIndicatorService) {}
	ngOnInit(): void {
	}
	
	checkPrivileges() {
		let enabled = this.cookieService.get('X-LogBook-Privileges-Enabled');
		this.privileges = enabled ? enabled.split(',') : [];
		return this.privileges.length;
	}
	
	cancelPrivileges() {
		this.privilegeIndicatorService.removePrivileges()
		.subscribe(() => {
			this.checkPrivileges();
			/*
			 * Is this the right thing to do here?  It seems a little off for a single-page application.
			 * But communicating the change in privilege to any components that might be affected by it is 
			 * complicated, and ensuring that any lingering state from elevated privileges even more so.
			 * Reloading the page ensures that all state resulting from elevated privileges is forgotten.
			 */
			window.location.reload();
		});
	}
}
